import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbProgressbarModule,NgbModalModule, NgbActiveModal, NgbPopoverModule, NgbPaginationModule, NgbDatepickerModule, NgbAlertModule, NgbAccordionModule, NgbTooltipModule, NgbDropdownModule, NgbModule, NgbPopover, NgbToast, NgbToastModule, NgbButtonLabel, NgbButtonsModule, NgbNavModule, NgbTimepicker,NgbProgressbar } from '@ng-bootstrap/ng-bootstrap';

import { NgSelectModule } from '@ng-select/ng-select';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgxFileDropModule } from 'ngx-file-drop';
import { SpinnerLoaderComponent } from "../shared/spinner-loader/spinner-loader.component";
import { ToastContainerComponent } from './toast-container/toast-container.component';

@NgModule({
  declarations: [
    SpinnerLoaderComponent,
    ToastContainerComponent



  ],
  entryComponents: [
    ToastContainerComponent

  ],

  imports: [
    //angular
    RouterModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    //bootstrap
    NgbModule,
    NgbModalModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbToastModule,
    NgbPaginationModule,
    NgbButtonsModule,
    NgbTooltipModule,
    NgxFileDropModule,
    NgbDatepickerModule,
    
    FontAwesomeModule,
    NgSelectModule,
    NgbNavModule,
    NgbProgressbarModule
    

  ],

  exports: [


    //angular
    CommonModule,

    FormsModule,
    ReactiveFormsModule,

    //bootstrap
    NgbModalModule,
    NgbPopoverModule,
    NgbDropdownModule,
    NgbToastModule,
    NgbPaginationModule,
    NgbPaginationModule,
    NgbButtonsModule,
    NgbTooltipModule,
    NgbDatepickerModule,
    FontAwesomeModule,

    NgxFileDropModule,

    SpinnerLoaderComponent,
    ToastContainerComponent,
    NgSelectModule,
    NgbNavModule,
    NgbTimepicker,
    NgbProgressbarModule

  ],
  providers: [],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class SharedModule { }
